setTimeout(()=>{
 const elm = document.querySelector('form[action="/cart/add"] input[name="id"]');
  if(elm){
    const observer = new MutationObserver(()=>{
      setTimeout(()=>{
        if (typeof BSS_B2B !== 'undefined' && BSS_B2B && BSS_B2B.cp && typeof BSS_B2B.cp.changeProductPrice === 'function') {
          BSS_B2B.cp.changeProductPrice(BSS_B2B.shopData, false, false);
        }
      }, 1000)
    })
    observer.observe(elm, {attributes: true})
  }
}, 300)
